import { render, staticRenderFns } from "./MarketCategoryEdit.vue?vue&type=template&id=1d933650"
import script from "./MarketCategoryEdit.vue?vue&type=script&lang=js"
export * from "./MarketCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports